import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "balance", "rate", "payment",
    "results", "monthlyInterest", "dailyRate", "principal",
    "interestPct", "principalPct", "interestBar", "principalBar"
  ]

  connect() { this.calculate() }

  calculate() {
    const balance = parseFloat(this.balanceTarget.value) || 0
    const apr     = parseFloat(this.rateTarget.value) || 0
    const payment = parseFloat(this.paymentTarget.value) || 0

    if (balance <= 0 || apr <= 0) {
      this.resultsTarget.classList.add("hidden")
      return
    }

    const monthlyInterest = balance * (apr / 100 / 12)
    const dailyRate       = apr / 100 / 365
    const principal       = Math.max(0, payment - monthlyInterest)
    const interestPct     = payment > 0 ? Math.min((monthlyInterest / payment) * 100, 100) : 100
    const principalPct    = 100 - interestPct

    this.monthlyInterestTarget.textContent = "$" + monthlyInterest.toFixed(2)
    this.dailyRateTarget.textContent       = (dailyRate * 100).toFixed(4) + "%"
    this.principalTarget.textContent       = payment > 0 ? "$" + principal.toFixed(2) : "—"
    this.interestPctTarget.textContent     = payment > 0 ? Math.round(interestPct) + "%" : "—"
    this.principalPctTarget.textContent    = payment > 0 ? Math.round(principalPct) + "%" : "—"
    this.interestBarTarget.style.width     = interestPct + "%"
    this.principalBarTarget.style.width    = principalPct + "%"

    this.resultsTarget.classList.remove("hidden")
  }

  useMinimum() {
    const balance = parseFloat(this.balanceTarget.value) || 0
    if (balance <= 0) return
    this.paymentTarget.value = Math.max(Math.round(balance * 0.02), 25)
    this.calculate()
  }
}
